import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-9e6dc9e3.js';
import 'classnames';

var Calculator = createSvgIcon(React__default.createElement(React__default.Fragment, null,
    React__default.createElement("path", { d: "M6 16H10", stroke: "currentColor", strokeWidth: "2" }),
    React__default.createElement("path", { d: "M14 16H18", stroke: "currentColor", strokeWidth: "2" }),
    React__default.createElement("path", { d: "M8 14L8 18", stroke: "currentColor", strokeWidth: "2" }),
    React__default.createElement("rect", { fill: "transparent", height: "16", stroke: "currentColor", strokeWidth: "2", width: "16", x: "4", y: "4" }),
    React__default.createElement("path", { d: "M4 12H20", stroke: "currentColor", strokeWidth: "2" }),
    React__default.createElement("path", { d: "M12 12L12 21", stroke: "currentColor", strokeWidth: "2" })), 'Calculator');

export { Calculator };
